export function getViewPort() {
  const width = window.innerWidth;

  if (width > 1200) {
    return "DESKTOP";
  } else if (width > 600) {
    return "TABLET";
  } else {
    return "PHONE";
  }
}
